// Los datos accionables del kit, a la vista en la Sala: qué decir, qué van a
// preguntar, qué vigilar y qué NO hacer. Reemplaza al índice de títulos del kit
// — trae el contenido útil sin tener que abrir el kit completo.

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  FaComments, FaQuestionCircle, FaExclamationTriangle, FaBan, FaRegCopy,
  FaFolderOpen,
} from 'react-icons/fa';
import {
  TechPanel, PanelHeader, PanelTitle, TechButtonGhost, borderSoft, mono,
} from '../../styles/techComponents';

const META = {
  mensajes: { icono: <FaComments />, titulo: 'Qué decir', color: 'var(--btn-primary)' },
  qa: { icono: <FaQuestionCircle />, titulo: 'Qué te van a preguntar', color: '#ffd166' },
  riesgos: { icono: <FaExclamationTriangle />, titulo: 'Qué vigilar', color: '#ef476f' },
  no_hacer: { icono: <FaBan />, titulo: 'Qué NO hacer', color: '#ef476f' },
};

const Item = styled.div`
  display: flex; align-items: flex-start; gap: 9px;
  padding: 9px 0; border-bottom: 1px solid ${borderSoft};
  font-size: 0.88rem; line-height: 1.55; color: var(--text-primary);
  &:last-child { border-bottom: none; }
  .b { flex-shrink: 0; margin-top: 7px; width: 5px; height: 5px; border-radius: 50%; background: ${(p) => p.$c}; }
  .t { flex: 1; min-width: 0; }
`;

const Par = styled.div`
  padding: 10px 0; border-bottom: 1px solid ${borderSoft};
  &:last-child { border-bottom: none; }
  .q { font-size: 0.86rem; font-weight: 600; color: var(--text-primary); line-height: 1.5; }
  .a { font-size: 0.85rem; color: var(--text-secondary); line-height: 1.6; margin-top: 5px; }
`;

const Texto = styled.p`
  margin: 0; font-size: 0.88rem; line-height: 1.65; color: var(--text-primary); white-space: pre-wrap;
`;

const Copiar = styled.button`
  font-family: ${mono}; font-size: 0.68rem; color: var(--text-secondary);
  background: rgba(255,255,255,0.04); border: 1px solid ${borderSoft};
  border-radius: 4px; padding: 3px 8px; cursor: pointer; margin-top: 8px;
  display: inline-flex; align-items: center; gap: 5px;
  &:hover { color: var(--btn-primary); border-color: rgba(0,180,216,0.4); }
`;

function Modulo({ m }) {
  const meta = META[m.tipo] || { icono: null, titulo: m.titulo, color: 'var(--btn-primary)' };
  const [copiado, setCopiado] = useState(false);

  const copiarTodo = async () => {
    const txt = m.texto
      || (m.items || []).join('\n')
      || (m.pares || []).map((p) => `${p.k}\n${p.v}`).join('\n\n');
    try { await navigator.clipboard.writeText(txt); setCopiado(true); setTimeout(() => setCopiado(false), 1800); }
    catch { /* sin portapapeles */ }
  };

  return (
    <TechPanel>
      <PanelHeader>
        <PanelTitle style={{ color: meta.color }}>{meta.icono} {meta.titulo}</PanelTitle>
      </PanelHeader>

      {m.texto && <Texto>{m.texto}</Texto>}

      {m.items && m.items.map((it, i) => (
        <Item key={i} $c={meta.color}><span className="b" /><span className="t">{it}</span></Item>
      ))}

      {m.pares && m.pares.map((p, i) => (
        <Par key={i}>
          <div className="q">{p.k}</div>
          <div className="a">{p.v}</div>
        </Par>
      ))}

      {(m.texto || (m.items && m.items.length) || (m.pares && m.pares.length)) && (
        <Copiar onClick={copiarTodo}><FaRegCopy /> {copiado ? 'copiado' : 'copiar'}</Copiar>
      )}
    </TechPanel>
  );
}

export default function KitFuncional({ kit }) {
  if (!kit) return null;
  const mods = kit.funcionales || [];
  if (mods.length === 0) {
    // Sin módulos accionables extraídos: al menos el acceso al kit.
    return (
      <TechPanel style={{ gridColumn: '1 / -1' }}>
        <PanelHeader>
          <PanelTitle>Kit de respuesta</PanelTitle>
          <Link to={`/urgencia?id=${kit.id}`}>
            <TechButtonGhost as="span"><FaFolderOpen /> Abrir el kit completo</TechButtonGhost>
          </Link>
        </PanelHeader>
        {kit.lectura && <Texto>{kit.lectura}</Texto>}
      </TechPanel>
    );
  }

  return (
    <>
      {mods.map((m, i) => <Modulo key={`${m.tipo}-${i}`} m={m} />)}
      <TechPanel style={{ gridColumn: '1 / -1' }}>
        <PanelHeader>
          <PanelTitle>Kit de respuesta completo</PanelTitle>
          <Link to={`/urgencia?id=${kit.id}`}>
            <TechButtonGhost as="span"><FaFolderOpen /> Abrir el kit (comunicado, posteos, plan, escenarios…)</TechButtonGhost>
          </Link>
        </PanelHeader>
        {kit.lectura && <Texto>{kit.lectura}</Texto>}
      </TechPanel>
    </>
  );
}
